// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  --tw-text-opacity: 1;
  color: rgb(17 28 68 / var(--tw-text-opacity)); }

p {
  --tw-text-opacity: 1;
  color: rgb(17 28 68 / var(--tw-text-opacity)); }

.container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem; }

@media (min-width: 640px) {
  .container {
    max-width: 640px; } }

@media (min-width: 768px) {
  .container {
    max-width: 768px; } }

@media (min-width: 1024px) {
  .container {
    max-width: 1024px; } }

@media (min-width: 1280px) {
  .container {
    max-width: 1280px; } }

.big-shadow {
  box-shadow: 0px 3.46736px 13.0026px rgba(44, 56, 145, 0.38); }

.ant-form-item {
  margin: 0px; }

.CookieConsent {
  bottom: 3rem !important;
  border-radius: 16px;
  align-items: center !important; }

.consent-button {
  display: flex;
  color: #ffffff;
  background-color: transparent;
  border: 1.5px solid #ffffff;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  font-weight: 300;
  cursor: pointer;
  align-items: center; }

.consent-button:hover {
  width: 100%;
  border-radius: 32px;
  justify-content: left; }

.consent-button .absolute {
  display: flex;
  color: #ffffff;
  transition: all 0.3s ease;
  align-items: center;
  font-size: 14px;
  left: 36%;
  font-weight: 600; }

.consent-button:hover .absolute {
  color: #1f43db;
  font-weight: 600;
  left: 16%; }

.consent-button > .arrow {
  width: 10px;
  height: 10px;
  border-right: 1.5px solid #ffffff;
  border-bottom: 1.5px solid #ffffff;
  position: relative;
  transform: rotate(-45deg);
  margin: 0 10px;
  transition: all 0.3s ease; }

.consent-button:hover > .arrow {
  transform: rotate(-45deg) translate(4rem, 4rem);
  border-color: #1f43db;
  margin-left: 2rem; }

.consent-button:hover {
  background-color: #ffffff;
  color: #1f43db;
  border: none; }

.cookie-modal .ant-modal-content {
  padding: 38px;
  background: #1f43db;
  color: #ffffff; }

.form-group {
  display: block;
  margin-bottom: 15px; }

.form-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer; }

.form-group label {
  position: relative;
  cursor: pointer; }

.form-group label:before {
  content: "";
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #80ACC7;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
  border-radius: 4px; }

.form-group input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  left: 9px;
  width: 6px;
  height: 14px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg); }

.form-group input:checked + label:before {
  background: #9DADF1; }
`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AACE;EAAA,oBAAM;EAAN,+CAAM;;AAIN;EAAA,oBAAM;EAAN,+CAAM;;AAGR;EACE,WAAW;EACX,iBAAM;EAAN,kBAAM;EACN,qBAAM;EAAN,sBAAM,EAAA;;AAGR;EACE;IACE,gBAAgB,EAAA,EACjB;;AAGH;EACE;IACE,gBAAgB,EAAA,EACjB;;AAGH;EACE;IACE,iBAAiB,EAAA,EAClB;;AAGH;EACE;IACE,iBAAiB,EAAA,EAClB;;AAGH;EACE,2DAA2D,EAAA;;AAI3D;EAAA,aAAM;;AAGR;EACE,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EAEzB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB,EAAA;;AAG3B;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,iBAAiB,EAAA;;AAGnB;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,yFACgD;EAChD,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB,EAAA;;AAG1B;EACE,mBAAmB,EAAA","sourcesContent":["* {\n  @apply text-secondary-500;\n}\n\np {\n  @apply text-secondary-500;\n}\n\n.container {\n  width: 100%;\n  @apply mx-auto;\n  @apply px-5;\n}\n\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n\n.big-shadow {\n  box-shadow: 0px 3.46736px 13.0026px rgba(44, 56, 145, 0.38);\n}\n\n.ant-form-item {\n  @apply m-0;\n}\n\n.CookieConsent {\n  bottom: 3rem !important;\n  border-radius: 16px;\n  align-items: center !important;\n}\n\n.consent-button {\n  display: flex;\n  color: #ffffff;\n  background-color: transparent;\n  border: 1.5px solid #ffffff;\n  height: 3rem;\n  width: 3rem;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  cursor: pointer;\n  align-items: center;\n}\n\n.consent-button:hover {\n  width: 100%;\n  border-radius: 32px;\n  justify-content: left;\n}\n\n.consent-button .absolute {\n  display: flex;\n  color: #ffffff;\n  transition: all 0.3s ease;\n  font-weight: 300;\n  align-items: center;\n  font-size: 14px;\n  left: 36%;\n  font-weight: 600;\n}\n\n.consent-button:hover .absolute {\n  color: #1f43db;\n  font-weight: 600;\n  left: 16%;\n}\n\n.consent-button > .arrow {\n  width: 10px;\n  height: 10px;\n  border-right: 1.5px solid #ffffff;\n  border-bottom: 1.5px solid #ffffff;\n  position: relative;\n  transform: rotate(-45deg);\n  margin: 0 10px;\n  transition: all 0.3s ease;\n}\n\n.consent-button:hover > .arrow {\n  transform: rotate(-45deg) translate(4rem, 4rem);\n  border-color: #1f43db;\n  margin-left: 2rem;\n}\n\n.consent-button:hover {\n  background-color: #ffffff;\n  color: #1f43db;\n  border: none;\n}\n\n.cookie-modal .ant-modal-content {\n  padding: 38px;\n  background: #1f43db;\n  color: #ffffff;\n}\n\n.form-group {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.form-group input {\n  padding: 0;\n  height: initial;\n  width: initial;\n  margin-bottom: 0;\n  display: none;\n  cursor: pointer;\n}\n\n.form-group label {\n  position: relative;\n  cursor: pointer;\n}\n\n.form-group label:before {\n  content: \"\";\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: 2px solid #80ACC7;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),\n    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);\n  padding: 10px;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-right: 5px;\n  border-radius: 4px;\n}\n\n.form-group input:checked + label:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -2px;\n  left: 9px;\n  width: 6px;\n  height: 14px;\n  border: solid #ffffff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.form-group input:checked + label:before {\n  background: #9DADF1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
